import { gql } from "@apollo/client";

export const EMAIL_ALGO = gql`
  mutation emailAlgo($id: Int!, $algo: Boolean!) {
    emailAlgo(id: $id, algo: $algo) {
      id
      message
      isError
    }
  }
`;
